<style scoped lang="scss">
.page {
  width: 1200px;
  margin: 0 auto;
  margin-top: 40px;
  padding-bottom: 90px;
}
</style>

<template>
  <div class="page">
    <HeadBar :qw-company-info="companyInfo" />

    <!-- <h1>企业微信layout</h1> -->
    <router-view />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import HeadBar from './comps/index/HeadBar'
export default {
  components: {
    HeadBar
  },
  data () {
    return {}
  },
  computed: {
    ...mapGetters(['companyInfo'])
  },
  mounted () {},
  methods: {}
}
</script>
